import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  addItemToArchive,
  getAllArchiveData,
  getCurrentArchiveStats,
  returnArchiveItem,
  updateArchiveItem,
} from "./operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
  state.archiveData = [];
};

const archiveSlice = createSlice({
  name: "archive",
  initialState: initialState.archive,
  reducers: {},
  extraReducers: builder =>
    builder
      .addCase(getAllArchiveData.pending, handlePending)
      .addCase(getAllArchiveData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.archiveData = action.payload;
      })
      .addCase(getAllArchiveData.rejected, handleRejected)

      .addCase(addItemToArchive.pending, handlePending)
      .addCase(addItemToArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.archiveData.push(action.payload);
      })
      .addCase(addItemToArchive.rejected, handleRejected)

      .addCase(updateArchiveItem.pending, handlePending)
      .addCase(updateArchiveItem.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.archiveData.findIndex(
          item => item.id === action.payload.id
        );
        if (index !== -1) {
          state.archiveData[index] = action.payload;
        }
      })
      .addCase(updateArchiveItem.rejected, handleRejected)

      .addCase(returnArchiveItem.pending, handlePending)
      .addCase(returnArchiveItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.archiveData = state.archiveData.filter(
          archiveItem => archiveItem.archive_id !== action.payload.archive_id
        );
      })
      .addCase(returnArchiveItem.rejected, handleRejected)

      // Get current archive stats +
      .addCase(getCurrentArchiveStats.pending, handlePending)
      .addCase(getCurrentArchiveStats.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentArchiveStat = action.payload;
      })
      .addCase(getCurrentArchiveStats.rejected, handleRejected),
});

export default archiveSlice.reducer;
